import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { computed } from 'vue'
import { useRouter } from 'vue-router'

import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { LOCALE_TITLES } from '@/i18n/helpers'
import { useI18nAddon } from '@/i18n/i18n'
import { AvailableLocale } from '@/i18n/types'
import { updateLocaleCookie } from '@/utils/cookie-parser'

interface LocaleSwitcherProps {
    disabled?: boolean
    selected?: boolean
    size?: 'm' | 'l'
    locale: AvailableLocale
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSwitcher',
  props: {
    disabled: { type: Boolean },
    selected: { type: Boolean },
    size: {},
    locale: {}
  },
  setup(__props: any) {

const i18nAddon = useI18nAddon()
const router = useRouter()

const props = __props

const localeName = computed(() => LOCALE_TITLES[props.locale])

const { currentLocale } = useI18nAddon()
const isSelected = computed(() => props.locale === currentLocale.value)

function updateLocale() {
    if (props.locale === currentLocale.value) {
        return
    }
    i18nAddon.setPreferredLocale(props.locale)
    updateLocaleCookie(props.locale)

    const switchLang = document
        .querySelector(`head link[data-locale="${props.locale}"]`)
        ?.getAttribute('data-lang-switch')
    if (!switchLang) {
        return
    }
    router.replace(switchLang)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
            _ctx.$style.button,
            _ctx.$style[`size_${props.size}`],
            props.disabled && _ctx.$style.disabled,
            isSelected.value && _ctx.$style.selected,
        ]),
    disabled: props.disabled,
    "data-interface-target": "switch-locale",
    onClick: updateLocale
  }, [
    _createVNode(Icon, {
      name: _ctx.locale,
      alt: `switch_to_${localeName.value}`,
      class: _normalizeClass(_ctx.$style.icon)
    }, null, 8, ["name", "alt", "class"]),
    _createVNode(Typography, {
      type: "label",
      size: "xs",
      responsive: false
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(localeName.value), 1)
      ]),
      _: 1
    })
  ], 10, _hoisted_1))
}
}

})